import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const ebayApi = createApi({
  reducerPath: "ebayApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }),
  tagTypes: ["EbayStore", "EbaySyncedProducts"],
  endpoints: (builder) => ({
    getConnectedEbayStore: builder.query({
      query: () => "ebay/store",
      providesTags: ["EbayStore"],
    }),
    getEbaySyncedProducts: builder.query({
      query: () => "ebay/synced-products",
      providesTags: ["EbaySyncedProducts"],
    }),
    initiateEbayOAuth: builder.mutation({
      query: (payload) => ({
        url: "ebay/auth/initiate",
        method: "POST",
        body: payload || {},
      }),
    }),
    handleEbayCallback: builder.mutation({
      query: ({ code, state, environment, marketplaceId }) => ({
        url: "ebay/auth/callback",
        method: "POST",
        body: { code, state, environment, marketplaceId },
      }),
      invalidatesTags: ["EbayStore"],
    }),
    disconnectEbay: builder.mutation({
      query: () => ({
        url: "ebay/store",
        method: "DELETE",
      }),
      invalidatesTags: ["EbayStore"],
    }),
    postProductToEbay: builder.mutation({
      query: ({ product, localProductId }) => ({
        url: "ebay/products",
        method: "POST",
        body: { product, localProductId },
      }),
      invalidatesTags: ["EbayStore", "EbaySyncedProducts"],
    }),
    bulkPostProductsToEbay: builder.mutation({
      query: (products) => ({
        url: "ebay/products/bulk",
        method: "POST",
        body: { products },
      }),
      invalidatesTags: ["EbayStore", "EbaySyncedProducts"],
    }),
  }),
});

export const {
  useGetConnectedEbayStoreQuery,
  useGetEbaySyncedProductsQuery,
  useInitiateEbayOAuthMutation,
  useHandleEbayCallbackMutation,
  useDisconnectEbayMutation,
  usePostProductToEbayMutation,
  useBulkPostProductsToEbayMutation,
} = ebayApi;
